import * as $ from 'jquery';
import { isEnableLineItemCost } from './utils';
import { getSizeLabel } from './domain';
import {
	COMPONENT_SIZE_FULL_WALL,
	PANELS_DOOR,
	LAYOUT_DOOR_FILTER,
	CLASS_HIDDEN_DOOR_PANEL_ITEM,
	CLASS_DISABLE_BY_LAYOUT,
	CLASS_DISABLE_BY_LOFTED_HORSERUNIN,
	CLASS_DISABLE_BY_STRUCTURE_COTTAGE_SCOUT,
	CLASS_DISABLE_BY_ZONE,
	CLASS_CUSTOM_SELECT_DISABLED,
	CLASS_DISABLE_BY_WL,
} from '../ssb_constants';

/**
 * Sync UI classes and disable states for Size and Height based on state classes.
 * @param invalidMode - The mode to handle invalid height options ('disable' or 'hide').
 */
export function syncSizeOptionsUI(invalidMode: string = 'disable') {
	// 1. Sync UI for WxL
	jQuery('#ssb-configurator-size-area')
		.find('option')
		.each((_, option) => {
			const width = Number(jQuery(option).attr('data-size-width'));
			const depth = Number(jQuery(option).attr('data-size-depth'));
			const customDiv = jQuery(`div[custom-select-value="${width}x${depth}"]`);

			const isDisabled =
				jQuery(option).hasClass(CLASS_DISABLE_BY_LAYOUT) ||
				jQuery(option).hasClass(CLASS_DISABLE_BY_LOFTED_HORSERUNIN) ||
				jQuery(option).hasClass(CLASS_DISABLE_BY_STRUCTURE_COTTAGE_SCOUT) ||
				jQuery(option).hasClass(CLASS_DISABLE_BY_ZONE);

			if (isDisabled) {
				jQuery(option).prop('disabled', true);
				customDiv.addClass(CLASS_CUSTOM_SELECT_DISABLED);
			} else {
				jQuery(option).prop('disabled', false);
				customDiv.removeClass(CLASS_CUSTOM_SELECT_DISABLED);
			}
		});

	// 2. Sync UI for Height
	jQuery('#ssb-configurator-size-height')
		.find('option')
		.each((_, option) => {
			const heightVal = Number(jQuery(option).attr('data-size-height'));
			const customDiv = jQuery(`div[custom-select-value="${heightVal}"]`);

			const isWLDisabled = jQuery(option).hasClass(CLASS_DISABLE_BY_WL);
			const isDisabled =
				jQuery(option).hasClass(CLASS_DISABLE_BY_LAYOUT) ||
				jQuery(option).hasClass(CLASS_DISABLE_BY_LOFTED_HORSERUNIN) ||
				jQuery(option).hasClass(CLASS_DISABLE_BY_ZONE) ||
				isWLDisabled;

			if (isDisabled) {
				jQuery(option).prop('disabled', true);
				customDiv.addClass(CLASS_CUSTOM_SELECT_DISABLED);

				if (invalidMode === 'hide' && isWLDisabled) {
					jQuery(option).hide();
					customDiv.hide();
				} else {
					jQuery(option).show();
					customDiv.show();
				}
			} else {
				jQuery(option).prop('disabled', false);
				jQuery(option).show();
				customDiv.show().removeClass(CLASS_CUSTOM_SELECT_DISABLED);
			}
		});
}

/**
 * Generates HTML options for a given size.
 *
 * @param {number} size - The size up to which the options should be generated.
 */
export function generateComponentSizeOption(size) {
	if (!size || size < 2) {
		return;
	}

	let result = `<option value="${COMPONENT_SIZE_FULL_WALL}" data-full-wall-size="${size}" >Full-wall</option>`;

	for (let i = 2; i < size; i++) {
		result += `<option value="${i}">${i}</option>`;
	}

	$('.component_size').html(result);
}

/**
 * Determines if the "show position components" class is present on the body element.
 *
 * @returns {boolean} True if the body element has the "show-position-components" class, otherwise false.
 */

export const isShowComponentPosition = () => {
	return $('body.show-position-components').length ? true : false;
};

/**
 * Handles search input in custom select dropdown.
 * Hides options that don't contain the search string.
 * @param {Event} e - The input event.
 */
export const handleSearchCustomSelect = (e) => {
	const content = e.target.value.replace(/ /g, '');
	const items = $(e.target).parent().children();
	for (let i = 1; i < items.length; i++) {
		const option = $(items[i]).text().replace(/ /g, '');
		if (-1 !== option.indexOf(content)) {
			$(items[i]).removeClass('hide-custom-option');
		} else {
			$(items[i]).addClass('hide-custom-option');
		}
	}
};

/**
 * Adds a warning message to the given element.
 *
 * @param {string} className CSS class name for the warning message.
 * @param {string} text The warning message to be displayed.
 * @returns {string} The HTML string for the warning message.
 */
export const addWarningMessage = (className, text) => {
	return `<div class="${className}" class="section-detail" style="padding: 0px; margin-bottom: 10px; font-style: italic; font-size: 0.9em; text-transform: none;"><span style="margin-right: 6px;" class="icon-warning-bold"></span>${text}</div>`;
};

/** Price labels the configurator uses instead of a number. */
export const SPECIAL_PRICE_LABELS = ['(n/a)', '(call for pricing)', '(included)'] as const;

/** True for "(n/a)", "(call for pricing)" or "(included)". */
export const isSpecialPriceLabel = (price: unknown): price is string =>
	typeof price === 'string' && (SPECIAL_PRICE_LABELS as readonly string[]).includes(price);

/**
 * Get the price element based on the provided price.
 *
 * @param {string|number} price - The price to display.
 * @returns {string} - The HTML string representing the price element.
 */
export const getPriceElement = (
	price,
	isShowPrice,
	isShowUpgradeCharge = true,
	priceType = null,
) => {
	if (!isShowPrice || !isShowUpgradeCharge) {
		return '';
	}

	if (!isEnableLineItemCost()) {
		return '';
	}

	if ('(included)' === price || '' === price || 0 == price) {
		if (priceType === 'n_a' || priceType === 'call_for_pricing') {
			let label;
			if (priceType === 'n_a') label = '(n/a)';
			if (priceType === 'call_for_pricing') label = '(call for pricing)';
			return `<p class="right">${label}</p>`;
		}
		return '<p class="right">(included)</p>';
	}

	if ('(n/a)' === price || '(call for pricing)' === price) {
		return `<p class="right">${price}</p>`;
	}

	return `<p class="right">${formatPrice(price)}</p>`;
};

/**
 * Format Price with USD
 * @param {Number} price price of one item
 */
export const formatPrice = (price) => {
	return renderPrice(price);
};

/**
 * Formats a price with USD currency
 * @param {number} price - the price to be formatted
 * @returns {string} - the formatted price
 */
export const renderPrice = (price) => {
	return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price);
};

export const triggerColorPicker = (selector: string, colorCode: string) => {
	$(`${selector} .ssb-option-color-picker`).val(colorCode).trigger('input');
};

/**
 * Apply filter to door options based on the current side and door type (normal vs. panel)
 *
 * If the provided door name is a panel door (present in DOOR_PANEL_NAME),
 * it uses LAYOUT_DOOR_FILTER configuration to determine allowed doors for the current layout.
 * Otherwise, it falls back to the generic panel filter which hides all panel doors.
 *
 * @param {string} side - The current side ('left' or 'right')
 * @param {string} [name] - Optional door component name
 */
export const applyDoorFilterForLayout = (side: string, name?: string): void => {
	const layoutId = document
		.querySelector(
			'#ssb-configurator-layout-option input[name="ssb-configurator-layout"]:checked',
		)
		?.getAttribute('data-layout-id');

	const sideConfig = LAYOUT_DOOR_FILTER[layoutId];

	if (!layoutId || !sideConfig) return;

	const isNormalDoor = undefined === name || !PANELS_DOOR.includes(name);
	resetDoorPanelVisibility();
	if (isNormalDoor) {
		filterDoorPanel();
	} else {
		filterDoorBySide(side, sideConfig);
	}
};

/**
 * Filter door panel by layout.
 * Hide door components that are not allowed for the active layout/side combination.
 */
const filterDoorPanel = (): void => {
	jQuery('.ssb-configurator-upgrade.door .component-item .ssb-option').each(function () {
		const componentName = jQuery(this).data('upgrade-component-name');
		if (PANELS_DOOR.includes(componentName)) {
			jQuery(this).parent().addClass(CLASS_HIDDEN_DOOR_PANEL_ITEM);
		}
	});

	hideEmptyDoorPanelGroups();
};

/**
 * Filter door panel by side.
 * Hide door components that are not allowed for the active side.
 *
 * @param {string} side - The current side ('left' or 'right')
 * @param {object} sideConfig - Side to config for layout
 */
const filterDoorBySide = (side: string, sideConfig: object) => {
	const allowedDoors = (side && sideConfig[side]) || sideConfig['*'];

	if (!allowedDoors) return;

	jQuery('.ssb-configurator-upgrade.door .component-item .ssb-option').each(function () {
		const componentName = jQuery(this).data('upgrade-component-name');
		if (!allowedDoors.includes(componentName)) {
			jQuery(this).parent().addClass(CLASS_HIDDEN_DOOR_PANEL_ITEM);
		}
	});

	hideEmptyDoorPanelGroups();
};

/**
 * Reset visibility before filtering
 */
const resetDoorPanelVisibility = (): void => {
	jQuery('.ssb-configurator-upgrade.door .component-item').removeClass(
		CLASS_HIDDEN_DOOR_PANEL_ITEM,
	);
	jQuery('.ssb-configurator-upgrade.door .accordion-group').removeClass(
		CLASS_HIDDEN_DOOR_PANEL_ITEM,
	);
};

/**
 * Hide accordion group header when all its items are hidden
 */
const hideEmptyDoorPanelGroups = (): void => {
	jQuery('.ssb-configurator-upgrade.door .accordion-group').each(function () {
		const visibleItems = jQuery(this)
			.find('.component-item')
			.filter(function () {
				return (
					this.style.display !== 'none' &&
					!jQuery(this).hasClass('hidden') &&
					!jQuery(this).hasClass(CLASS_HIDDEN_DOOR_PANEL_ITEM)
				);
			});

		if (visibleItems.length === 0) {
			jQuery(this).addClass(CLASS_HIDDEN_DOOR_PANEL_ITEM);
		}
	});
};

/**
 * Update custom select UI for WxL and Height
 */
export const updateCustomSizeUI = (widthDepth: string, height: number | string) => {
	const tmpSizes = widthDepth.split('x');
	let sizeLabel: any = { heightLabel: `${height}'` };
	const sizeOption = jQuery('#ssb-configurator-size-area').children(
		`option[data-size-width="${tmpSizes[0]}"][data-size-depth="${tmpSizes[1]}"]`,
	);

	if (sizeOption.length) {
		sizeLabel = getSizeLabel(sizeOption, Number(height));
	}

	const widthDepthLabel = sizeLabel['widthDepthLabel'] || widthDepth;

	jQuery(`#ssb-sizes .select-items div`).removeClass('same-as-selected');
	jQuery(`#ssb-sizes .select-items div[custom-select-value="${widthDepth}"]`).addClass(
		'same-as-selected',
	);
	jQuery(`#ssb-sizes .custom-select-selected`).html(widthDepthLabel);

	setHeightCustomSelectState(sizeLabel['heightLabel'], height);
};

/**
 * Update only the height custom select UI (display label + selected state).
 * Does not trigger any change events to avoid double resize.
 */
export const updateCustomHeightUI = (height: number) => {
	const selectedWL = jQuery('#ssb-configurator-size-area').children('option:selected');
	const sizeLabel = selectedWL.length
		? getSizeLabel(selectedWL, Number(height))
		: { heightLabel: `${height}'` };

	setHeightCustomSelectState(sizeLabel['heightLabel'], height);
};

/**
 * Set the height custom select display label and selected state.
 */
const setHeightCustomSelectState = (heightLabel: string, height: number | string) => {
	jQuery(`#ssb-height .custom-select-selected`).html(heightLabel);
	jQuery(`#ssb-height .select-items div`).removeClass('same-as-selected');
	jQuery(`#ssb-height .select-items div[custom-select-value="${height}"]`).addClass(
		'same-as-selected',
	);
};
